import { useCallback, useContext, useEffect } from "react";
import { store } from "../components/Store";
import { AVAILABLE_LANGUAGES_ARRAY, STORAGE_KEYS } from "../config/constants";


export const useLanguageSelection = () => {
	const { dispatch, state } = useContext(store);
	const isAuth = state.sesionActiva === "SI";
	const LANGUAGE_KEY = STORAGE_KEYS.language;

	useEffect(() => {
		updateStateLanguage({ lang: getLanguageFromLocalStorage() });
	}, []);

	const getLanguageFromLocalStorage = () => localStorage.getItem(LANGUAGE_KEY);

	const getValidLanguage = useCallback(
		({ lang }) => {
			// Si no llega un idioma explicito, el fallback depende del tipo de sesion.
			const fallbackLang = lang || "es";
			if (AVAILABLE_LANGUAGES_ARRAY.includes(fallbackLang)) {
				return fallbackLang;
			}
			// Ante cualquier valor desconocido, la app cae a ingles.
			return "es";
		},
		[isAuth],
	);

	const updateStateLanguage = ({ lang }) => {
		const finalLang = getValidLanguage({ lang });
		dispatch({
			type: "CHANGE_VALUE",
			property: "language",
			value: finalLang,
		});
	};

	const updateLocalStorageLanguage = ({ lang }) => {
		const finalLang = getValidLanguage({ lang });
		localStorage.setItem(LANGUAGE_KEY, finalLang);
	};

	const setLanguage = useCallback(({ lang, saveOnStorage = true }) => {
		updateStateLanguage({ lang });
		if (saveOnStorage) {
			updateLocalStorageLanguage({ lang });
		}
	}, []);

	return {
		setLanguage,
	};
};
